import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem } from "../../types/types";

const storage = localStorage.getItem('cart')
const initialState: CartItem[] = !!storage ? JSON.parse(storage) : []

const cart = createSlice({
    name: 'cart',
    initialState,
    reducers:{
        addCartItem: (state, action: PayloadAction<CartItem>) => {
            if(state.find(item => item.id === action.payload.id)) return [...state]
            localStorage.setItem('cart', JSON.stringify([...state, action.payload]))
            return [...state, action.payload]
        },
        removeCartItem: (state, action: PayloadAction<number>) => {
            const arrayToSave = state.filter(item => item.id !== action.payload)
            localStorage.setItem('cart', JSON.stringify([...arrayToSave]))
            return arrayToSave
        },
        replaceCartItem: (state, action: PayloadAction<CartItem>) => {
            const newCart = state.map(item => {
                if(item.id === action.payload.id){
                    return action.payload
                } else{
                    return item
                }
            })
            localStorage.setItem('cart', JSON.stringify(newCart))
            return newCart
        },
        clearCart: (state) => {
            localStorage.removeItem('cart')
            return []
        }
        
    }
})


export const cartReducer = cart.reducer
export const {addCartItem, removeCartItem, replaceCartItem, clearCart} = cart.actions